import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-300 py-12 border-t border-white/10" data-id="element-174">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-175">
        <h2 className="text-2xl font-black text-white mb-2" data-id="element-176">
          ⚽ MEGAPACK FÚTBOL RESUELTO™
        </h2>
        <p className="font-medium mb-8" data-id="element-177">
          El sistema de entrenamiento N°1 para instructores de fútbol en
          Argentina.
        </p>
        <p className="italic text-gray-400 mb-8" data-id="element-178">
          Porque entrenar fútbol no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-bold mb-12" data-id="element-179">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-180">
            📧 contacto@recursosfitness.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-181">
            📲 @recursosfitness.ar
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-182">
            🌐 recursosfitness.shop
          </a>
        </div>

        <p className="text-xs text-gray-500" data-id="element-183">
          © RecursosFitness™ 2026 — Todos los derechos reservados. Prohibida
          la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}